import ProgressChart from './_ProgressChart';

export default ProgressChart;
